module.exports = __webpack_public_path__ + "img/luxury_top@2x.41b06eca.png";